module.exports = __webpack_public_path__ + "media/logo-app-navbar.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/media/brand/logo-app-navbar.svg
// module id = 815
// module chunks = 0